<template>
  <div>
    로그아웃 중입니다...
  </div>
</template>
<script>
import AuthService from '@/service/auth/AuthService'

export default {
  async created() {
    AuthService.signout()
    let device = localStorage.getItem('device')
    if (device) {
      this.$router.push({ name: 'signin' })
    } else {
      this.$router.push({ name: 'main' })
    }
  }
}
</script>
